export default __webpack_public_path__ + "static/media/kolnaexplorer.b1114e53.jpg";